import React, { useState, useEffect, useRef } from 'react';
import Spline from '@splinetool/react-spline';
import './Hero.css';
import { useLanguage } from '../contexts/LanguageContext';
import { HiArrowUpRight } from 'react-icons/hi2';

const Hero = () => {
  const [offsetY, setOffsetY] = useState(0);
  const [splineLoaded, setSplineLoaded] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const { t } = useLanguage();
  const heroSectionRef = useRef(null);
  const stickyWrapperRef = useRef(null);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    const handleScroll = () => {
      const scrollY = window.pageYOffset;
      setOffsetY(scrollY);
      
      // Hero section'ın yüksekliğini mobil/desktop'a göre ayarla
      if (heroSectionRef.current) {
        const vh = window.innerHeight;
        const heightMultiplier = window.innerWidth < 768 ? 1.5 : 2.0; // Daha kısa yapıyoruz
        heroSectionRef.current.style.height = `${vh * heightMultiplier}px`;
      }
    };
    
    const handleResize = () => {
      checkMobile();
      if (heroSectionRef.current) {
        const vh = window.innerHeight;
        const heightMultiplier = window.innerWidth < 768 ? 1.5 : 2.0; // Daha kısa yapıyoruz
        heroSectionRef.current.style.height = `${vh * heightMultiplier}px`;
      }
    };
    
    // İlk yüklemede de çalıştır
    checkMobile();
    handleScroll();
    handleResize();
    
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <section ref={heroSectionRef} className="hero-scroll-section">
      <div ref={stickyWrapperRef} className="hero-sticky-wrapper">
        <div className="hero">
          <h1>
            {t('hero.title')} <span className="highlight">Neurocortex</span>
            <button 
              className="arrow-button"
              onClick={() => {
                const neurocortexSection = document.querySelector('#cozum');
                if (neurocortexSection) {
                  neurocortexSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
              }}
              aria-label="Neurocortex bölümüne git"
            >
              <HiArrowUpRight />
            </button>
            <br />
            {t('hero.subtitle')}
          </h1>
        </div>

        <div
          className="robot-container"
          style={{ 
            transform: `translateY(${Math.min(-offsetY * (isMobile ? 0.6 : 0.5), 0)}px)`,
            transition: 'transform 0.1s ease-out'
          }}
        >
          {!splineLoaded && (
            <div className="robot-placeholder">
              <div className="robot-icon">🤖</div>
              <p>{t('hero.loading')}</p>
            </div>
          )}
          <Spline
            scene="https://prod.spline.design/fP0LH65i8bXQDQjZ/scene.splinecode"
            onLoad={() => setSplineLoaded(true)}
            style={{ display: splineLoaded ? 'block' : 'none' }}
          />
        </div>
      </div>
    </section>
  );
};

export default Hero; 